export default "__VITE_ASSET__DgbAM$c9__"